import * as URLS from 'modules/urls'
import { OPS_SOLUTION_PATHS, USE_CASE_PATHS } from 'modules/solutions/solutionUrls'

export const defaultNavItems = [
  {
    title      :'Solutions',
    link       :USE_CASE_PATHS.LIST,
    key        :'solutions',
    hasSubItems:true,
    subItems   :[
      {
        title:'RLHF',
        link :USE_CASE_PATHS.RLHF,
      },
      {
        title:'Side by side RL',
        link :USE_CASE_PATHS.SIDE_BY_SIDE_RL,
      },
      {
        title:'Original content',
        link :USE_CASE_PATHS.ORIGINAL_CONTENT,
      },
      {
        title:'Creative hallucination',
        link :USE_CASE_PATHS.CREATIVE_HALLUCINATION,
      },
      {
        title:'Safety, ethics, & compliance',
        link :USE_CASE_PATHS.SAFETY_ETHICS_COMPLIANCE,
      },
      {
        title:'Honesty and factuality training',
        link :USE_CASE_PATHS.HONESTY_FACTUALITY_TRAINING,
      },
      {
        title:'LLM prompting',
        link :USE_CASE_PATHS.LLM_PROMPTING,
      },
      {
        title:'Data classification & indexing',
        link :USE_CASE_PATHS.CLASSIFICATION,
      },
      {
        title:'Engine annotation',
        link :USE_CASE_PATHS.ENGINE_ANNOTATION,
      },
      {
        title:'LLM fluency & relevancy grading',
        link :USE_CASE_PATHS.LLM_FLUENCY_RELEVANCY_GRADING,
      },
      {
        title:'Chain-of-thought reasoning',
        link :USE_CASE_PATHS.CHAIN_OF_THOUGHT_REASONING,
      },
    ],
  },
  {
    title      :'Case studies',
    key        :'caseStudies',
    hasSubItems:true,
    subItems   :[
      {
        link :URLS.CASE_STUDIES.MATS,
        title:'MATS, UC London, and Anthropic',
      },
    ],
  },
  {
    title      :'Ops services',
    link       :OPS_SOLUTION_PATHS.LIST,
    key        :'opsServices',
    hasSubItems:true,
    subItems   :[
      {
        title:'Outsourced ops assistants',
        link :URLS.SITE.OPS_HOME,
      },
      {
        title:'How it works',
        link :URLS.SITE.HOW_IT_WORKS,
      },
      {
        title:'Explore ops solutions',
        link :OPS_SOLUTION_PATHS.LIST,
      },
    ],
  },
  {
    title      :'Careers',
    key        :'careers',
    hasSubItems:true,
    subItems   :[
      {
        title:'Apply to train AI',
        key  :'ai-trainer',
        link :URLS.SITE.AI_TRAINER,
      },
      {
        title:'Join our team',
        key  :'careers',
        link :URLS.SITE.CAREERS,
      },
    ],
  },
  {
    title:'Blog',
    link :URLS.BLOG.HOME,
    key  :'blog',
  },
]
